import { SemesterEnum } from "@/model/data/fitnessStatistics/SemesterEnum";

export class DownloadFitnessStatisticsReportReqData {
    year: number;
    semester: SemesterEnum;
    branchId: number | undefined;
    installationNames: string[] = [];
    glnReporter: string;
    glnOwner: string;
    fromConf: boolean;
    mode: string;
}
